import { styled } from '@goodfynd/theme';

export const StyledContainer = styled('section', {
  backgroundColor: '$Neutral01',
  borderRadius: 16,
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  overflow: 'hidden',
  padding: 24,
  position: 'relative',
  width: '100%',
  '@sm': {
    borderRadius: 0,
    padding: 16,
  },
  '@lg': {
    paddingRight: 624,
  },
});

export const StyledMapContainer = styled('div', {
  alignItems: 'center',
  backgroundColor: '$GreenLightest',
  display: 'none',
  height: '100%',
  justifyContent: 'center',
  overflow: 'hidden',
  position: 'absolute',
  right: 0,
  top: 0,
  width: 600,
  '> img': {
    width: '100%',
  },
  '@lg': {
    display: 'flex',
  },
});

export const StyledMapContainerMobile = styled('div', {
  alignItems: 'center',
  backgroundColor: '$GreenLightest',
  borderRadius: 8,
  display: 'flex',
  justifyContent: 'center',
  marginTop: 8,
  overflow: 'hidden',
  '> img': {
    width: '100%',
  },
  '@sm': {
    maxHeight: 150,
  },
  '@md': {
    maxHeight: 150,
  },
  '@lg': {
    display: 'none',
  },
});
